// src/app/core/utils/url-builder.ts
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' 
})

export class URLBuilder {
  private baseUrl: string;

  constructor() {
    this.baseUrl = environment.apiUrl;
  }

  // Construct simple endpoints without parameters
  buildEndpoint(endpoint: string): string {
    const fullUrl = `${this.baseUrl}${endpoint}`;
    console.log('Constructed URL:', fullUrl);
    return fullUrl;
  }

  // Construct endpoints with path parameters
  buildPathEndpoint(endpoint: string, params: { [key: string]: any }): string {
    let url = `${this.baseUrl}${endpoint}`;
    for (const key in params) {
      url = url.replace(`:${key}`, params[key]);
    }
    return url;
  }

  // Add query parameters to endpoints
  buildQueryEndpoint(
    endpoint: string,
    queryParams: { [key: string]: any }
  ): string {
    const query = new URLSearchParams(queryParams).toString();
    return `${this.baseUrl}${endpoint}?${query}`;
  }
}

// Example usage:
// const urlBuilder = new URLBuilder();
// const url = urlBuilder.buildPathEndpoint('/service/processo/:id/alterar', { id: 123 });
